export default __webpack_public_path__ + "assets/3dded1aaccb2eff58b7a0d1e0a8e6f5e.png";